import { useEffect, useState } from "react";
import { API_URL } from "../config";
import { authFetch } from "../utils";

export function useGetFwi({ meteoId, from, to } = {}) {
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [refreshToken, setRefreshToken] = useState(0);

  const refetch = () => setRefreshToken((x) => x + 1);

  useEffect(() => {
    if (!meteoId) return;

    const fetchData = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const params = new URLSearchParams();
        if (from) params.set("from", from);
        if (to) params.set("to", to);
        const url = `${API_URL}fwi/${meteoId}${params.toString() ? `?${params.toString()}` : ""}`;

        const res = await authFetch(url);
        if (!res.ok) throw new Error(`Error al obtener FWI: ${res.status} ${res.statusText}`);
        const json = await res.json();
        const cleaned = json
          .filter((d) => d && typeof d.fwi === "number" && typeof d.time === "string")
          .sort((a, b) => new Date(a.time) - new Date(b.time));
        setData(cleaned);
      } catch (e) {
        setError(e);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [meteoId, from, to, refreshToken]);

  return { observations: data, isLoading, error, refetch };
}
